import styled, { css } from 'styled-components'

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    box-shadow: 2px 2px 8px -4px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.radius.medium};
  `}
`
